module.exports = __webpack_public_path__ + "sanctadomenica.png?5a4d0ad026b73a57b292c1e652f053a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sanctadomenica.png
// module id = 1009
// module chunks = 2